import * as moment from 'moment';
import { FormEvent, useEffect, useState } from 'react';
import { Button, Col, ControlLabel, FormControl, FormGroup, HelpBlock, Modal, Row, Well } from 'react-bootstrap'
import { ISerologyTracking } from '@nkr/models/index';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    data: ISerologyTracking,
    onSubmit: (trackingNumber: string, shippedDate: string) => void,
    onCancel: () => void
}

const MarkShippedBack = (props: IProps) => {
    const [trackingNumber, setTrackingNumber] = useState('');
    const [shippedDate, setShippedDate] = useState(moment().format('YYYY-MM-DD HH:mm'));
    const [validTrackingNumber, setValidTrackingNumber] = useState(true);
    const [validShippedDate, setValidShippedDate] = useState(true);
    const [dirty, setDirty] = useState(false);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setShippedDate(moment().format('YYYY-MM-DD HH:mm'));
            setValidTrackingNumber(true);
            setValidShippedDate(true);
            setTrackingNumber('');
        }
    }, [props.show]);

    const handleTrackingNumberChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        setTrackingNumber(e.currentTarget.value);
    };

    const handleShippedDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        setShippedDate(e.currentTarget.value);
    };

    const handleSubmit = () => {
        let isValidTrackingNumber = trackingNumber != '';
        let isValidShippedDate = moment(shippedDate).isValid();

        if (isValidTrackingNumber && isValidShippedDate) {
            props.onSubmit(trackingNumber, shippedDate);
        } else {
            setValidTrackingNumber(isValidTrackingNumber);
            setValidShippedDate(isValidShippedDate)
            setDirty(true);
        }
    };

    let donorCenter = props.data != null ? props.data.donorCenter : '';
    let donorAlias = props.data != null ? props.data.donorAlias : '';
    let swap = props.data != null ? `${props.data.chainNumber}/${props.data.clusterNumber}/${props.data.positionNumber}` : '';

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel} style={{ zIndex: 99999999 }}>
            <Modal.Header closeButton>
                <Modal.Title>Mark Shipped Back</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Well bsSize='sm'>
                    <div style={{ marginBottom: 15 }}>Please confirm that you would like to mark the following serology as <strong>Shipped Back</strong>...</div>

                    <Row>
                        <Col xs={12} lg={3}>Donor Center:</Col>
                        <Col xs={12} lg={9}>{donorCenter}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={3}>Donor Alias:</Col>
                        <Col xs={12} lg={9}>{donorAlias}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={3}>Swap:</Col>
                        <Col xs={12} lg={9}>{swap}</Col>
                    </Row>
                </Well>

                <FormGroup validationState={dirty && !validTrackingNumber ? 'error' : null}>
                    <ControlLabel>Tracking #</ControlLabel>
                    <FormControl
                        value={trackingNumber}
                        onChange={handleTrackingNumberChange}
                    />

                    {dirty && !validTrackingNumber && (
                        <HelpBlock>This is required</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={dirty && !validShippedDate ? 'error' : null}>
                    <ControlLabel>Shipped Date/Time</ControlLabel>
                    <FormControl
                        type='datetime-local'
                        value={shippedDate}
                        onChange={handleShippedDateChange}
                    />

                    {dirty && !validShippedDate && (
                        <HelpBlock>This is required</HelpBlock>
                    )}
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Submit</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MarkShippedBack;